import {useTranslation} from 'react-i18next';
import {useDispenserControls, useGuestCardStore, useKioskoStore} from 'context/kiosko';
import {Button} from '@chekin/guestapp-ui-kit';

type Props = {
  onClose: () => void;
  onMaybeLater: () => void;
};
function IncompletePrintedCardContent({onClose, onMaybeLater}: Props) {
  const {t} = useTranslation();
  const pending = useKioskoStore(state => state.cards.pending);
  const guestCardData = useGuestCardStore(state => state.guestCardData);
  const {printCard} = useDispenserControls();

  return (
    <div className="flex flex-col gap-[112px]">
      <div>
        <div className="text-kiosko-l font-semibold text-[#333] mb-2 text-center">
          {t('do_you_want_to_print_more_keycards')}
        </div>
        <div className="text-kiosko-s text-[#666] mb-2 text-center">
          {t('you_can_print_up_to_4_keycards', {pending})}
        </div>
      </div>

      <div className="flex flex-col gap-14">
        {guestCardData && (
          <Button
            onClick={() => {
              printCard(guestCardData);
              onClose();
            }}
            size="md"
            className="m-auto gap-[18px]"
            variant="outline"
          >
            {t('print_new_keycard')}
          </Button>
        )}
        <Button
          onClick={onMaybeLater}
          size="md"
          className="m-auto gap-[18px]"
          variant="outline"
        >
          {t('maybe_later')}
        </Button>
      </div>
    </div>
  );
}

export {IncompletePrintedCardContent};
